import Chartist from 'chartist'

export default {
  Chartist,
  install(Vue) {
    /** Chartist setip */
    Object.defineProperty(Vue.prototype, '$Chartist', {
      get() {
        return this.$root.Chartist
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/core/charts/index.js